import React, {useEffect} from "react";
import "../CSS/styles.css";
import proj from "../../assets/proj.png";
import AOS from 'aos';
import 'aos/dist/aos.css';

const Slider5 = () => {
  useEffect(() => {
        AOS.init({
          duration: 1000,
          once: false,
        });
      }, []);
  return (
    <div className="container-fluid mt-lg-5 mt-2 px-0" data-aos="fade-down">
      <div className="row pt-4 justify-content-center">
        <div className="col-12">
          <div className="image-gradient-wrap3">
            <img src={proj} alt="2" className="img-fluid" />
            <div className="gradient-over3"></div>
            <div className="over-cont3 d-flex flex-column align-items-center justify-content-center">
              <h1 className="fw-bolder mt-3 inter h0 mb-0">Our Projects</h1>
              <p className="mb-0 mt-lg-3">Explore our work delivering innovative solutions for clients worldwide.</p>
            </div>
          </div>
        </div>

      </div>
    </div>
  );
};

export default Slider5
